import React, { Component } from "react";
import styles from "./PlusMinus.module.scss";


const PlusMinus = props => (
	<div className={styles.circle_plus} onClick={() => props.toggle()}>
		<div className={ props.state ? (props.label && styles.without_label) + " " + styles.circle_open : (props.label && styles.without_label)+ " " + styles.circle}>
			<div
				className={
					props.state
						? styles.horizontal_open
						: styles.horizontal_closed
				}
			/>
			<div
				className={
					props.state ? styles.vertical_open : styles.vertical_closed
				}
			/>
			{props.label && <span style={props.contentAlign === "start"
									? {position: "absolute", width: "250%", left: "-250%", top: "50%", transform: "translateY(-50%)"} : {position: "absolute", width: "250%", right: "-275%", top: "50%", transform: "translateY(-50%)"}}>{props.label}</span>}
		</div>
	</div>
);

export default PlusMinus;



// WEBPACK FOOTER //
// ./src/components/plus-minus/index.js